<template>
<div>
    <vs-card style="min-height:600px">
        <vs-row>
            <vs-col class="w-1/2">
                <h4 style="padding-left:20%">Change or Vacate</h4>
            </vs-col>
            <vs-col class="w-1/2">
                <router-link :to="{path:'/patientTray',query:{patientId:patientId}}" style="margin-left:95%">
                    <feather-icon icon="XIcon" class="custom-class"></feather-icon>
                </router-link>
            </vs-col>
        </vs-row>
        <vs-divider></vs-divider>

        <div style="padding-left:4%;padding-right:4%">
            <vs-row class="mb-2">
                <vs-col vs-lg="2" class="topPad">
                    <span class="inputStyles">Booked Date</span>
                </vs-col>
                <vs-col vs-lg="2" class="sm:w-1/6 w-full">
                    <vs-input class="w-full" v-model="bookedDate" readonly v-validate="'required'" name="bookedDate" />
                </vs-col>
            </vs-row>

            <vs-row class="mb-2">
                <vs-col vs-lg="2" class="topPad">
                    <span class="inputStyles">Released Date</span>
                </vs-col>
                <vs-col vs-lg="2" class="sm:w-1/6 w-full">
                    <vs-input class="w-full" v-model="releasedDate" readonly v-validate="'required'" name="releasedDate" />
                </vs-col>
            </vs-row>

            <vs-row class="mb-2">
                <vs-col vs-lg="2" class="topPad">
                    <span class="inputStyles">No of Days</span>
                </vs-col>
                <vs-col vs-lg="2" class="sm:w-1/6 w-full">
                    <vs-input class="w-full" v-model="noofDays" v-validate="'required'" name="noOfDays" />
                </vs-col>
            </vs-row>

            <vs-row class="mb-2">
                <vs-col vs-lg="2" class="topPad">
                    <span class="inputStyles">Calculated Amount</span>
                </vs-col>
                <vs-col vs-lg="2" class="sm:w-1/6 w-full">
                    <vs-input class="w-full" v-model="calcAmount" v-validate="'required'" name="calcAmount" />
                </vs-col>
            </vs-row>
        </div>

        <div style="padding-left:4%;padding-right:4%;margin-top:2%">
           <input type="radio" v-model="action" value="Vacate" style="margin-left:2%;margin-right:1%">Vacate Room
           <input type="radio" v-model="action" value="Change" style="margin-left:8%;margin-right:1%">Change Room
        </div>

        <div v-if="this.action == 'Change'" style="padding-left:19%;padding-right:4%;margin-top:2%">
            <vs-row>
                <vs-col vs-lg="2">
                    <vs-button class="w-full" color="primary" type="border" @click="selectRooms" >Select Room</vs-button>
                </vs-col>
            </vs-row>
            <vs-row>
                <div v-if="show" style="margin-top:2%">
                    <vs-col >
                        <p>Room No - {{selectedRoomNo}}</p>
                        <p>Category - {{roomCategory}}</p>
                    </vs-col>
                </div>
            </vs-row>
        </div>
       
    <!-- footer -->
    </vs-card>
    <vs-row>
        <vs-card class="footer">
            <div class="btn-group" style="margin-left:81%">
                <vs-button :to="{path:'/patientTray',query:{patientId:patientId}}" color="danger" type="filled">Exit</vs-button>
                <vs-button color="success" @click="saveDetails" type="filled">Save</vs-button>
            </div>
        </vs-card>

        <!-- ------- -->
    </vs-row>

    <!-- popup -->

    <vs-popup class="holamundo" title="Room Details" :active.sync="popupActivo">
        <div class="vx-row">
            <div class="vx-col w-full md:w-1/2">
                <div class="vx-row mb-6">
                    <div class="vx-col sm:w-1/3 w-full" style="padding-top:2%">
                        <span class="popup_lbl inputStyles" >Room Type</span>
                    </div>
                    <div class="vx-col sm:w-2/3 w-full">
                        <select v-model="categoryId" name="Category"  v-validate="'required'" class=" vs-select--input myselect" style="height: 36px;">
                            <option class="vs-component" v-for="(item,index) in roomType" v-bind:key="index" :value="item.id">{{item.name}}</option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="vx-col w-full md:w-1/2">
                 <div class="vx-row mb-6">
                    <div class="vx-col sm:w-1/3 w-full" style="padding-top:2%">
                        <span class="popup_lbl inputStyles">Room Status</span>
                    </div>
                    <div class="vx-col sm:w-2/3 w-full">
                        <select v-model="statusType" name="Category"  v-validate="'required'" class=" vs-select--input myselect" style="height: 36px;" @change="searchRoomDetails">
                            <option class="vs-component" v-for="(item,index) in roomStatus" v-bind:key="index" :value="item.id">{{item.name}}</option>
                        </select>
                    </div>
                </div>
            </div>
        </div>

        <div>
            <vs-row vs-w="12">
                <vs-col v-for="(item,index) in roomDetails" v-bind:key="index" vs-type="flex" vs-justify="center" vs-align="center" vs-w="4">
                    <vs-row>
                        <vs-col>
                            <!-- <button v-on:click="storeDetails(item)" style="border: none;height: 5%;color: grey;">
                            <vs-card actionable class="cardx">
                              
                                        <div class="vx-row mb-2">
                                            <div class="vx-col sm:w-1/2 w-full">
                                                <span>Room No</span>
                                            </div>
                                            <div class="vx-col sm:w-1/3 w-full">
                                                <span style="font-weight:500">{{item.roomNo}}</span>
                                            </div>
                                        </div>
                                        <div class="vx-row mb-2">
                                            <div class="vx-col sm:w-1/2 w-full">
                                                <span>Category</span>
                                            </div>
                                            <div class="vx-col sm:w-1/3 w-full">
                                                <span style="font-weight:500">{{item.category}}</span>
                                            </div>
                                        </div>
                                        <div class="vx-row mb-2">
                                            <div class="vx-col sm:w-1/2 w-full">
                                                <span>Rate</span>
                                            </div>
                                            <div class="vx-col sm:w-1/3 w-full">
                                                <span style="font-weight:500">{{item.rate}}</span>
                                            </div>
                                        </div>
                                        <div class="vx-row mb-2">
                                            <div class="vx-col sm:w-1/2 w-full">
                                                <span>Status</span>
                                            </div>
                                            <div class="vx-col sm:w-1/3 w-full" v-if="item.status == 'Booked'">
                                                <span style="color:red">{{item.status}}</span>
                                            </div>
                                            <div class="vx-col sm:w-1/3 w-full" v-if="item.status == 'Vacant'">
                                                <span style="color:green">{{item.status}}</span>
                                            </div>
                                        </div>
                             
                            </vs-card>
                             </button> -->
                              <div class=" text-center example ex1">
                                    <label class="radio red" @click="storeDetails(item)">
                                        <input type="radio" name="group1" :value="item.roomId" v-model="item.roomId" />
                                        <span>
                                            <h5>{{item.catagory}}</h5>
                                            <p>RoomNo:{{item.roomNo}}</p>
                                            <p>Rate:{{item.rate}}</p>
                                            <!-- <div v-if="item.status == 'Booked'">
                                                <p>Status:{{item.status}}</p>
                                            </div> -->
                                            <p>Status:{{item.status}}</p>
                                               
                                        </span>
                                    </label>
                                </div>
                        </vs-col>
                    </vs-row>
                </vs-col>
                <vs-col>
                <!-- <div style="margin-top:2%" v-if="roomDetails.length">
                    <vs-pagination :total="totalRecord" v-model="currentx" @change="searchRoomDetails"></vs-pagination>
                </div> -->
                </vs-col>
            </vs-row>
        </div>

        </vs-popup>


    <!-- popup end -->



</div>
</template>

<script>
export default {
     data() {
        return {
            bookedDate:"",
            releasedDate:new Date().toISOString().slice(0, 10),
            noofDays:"",
            calcAmount:"",
            patientId: "",ipNo:"",
            action:"",
            popupActivo:false,
            roomType: [{id:"",name:"Select"}],
            roomStatus: [{id:"",name:"Select"},{id:"Booked",name:"Booked"},{id:"Vacant",name:"Vacant"}],
            statusType:"",
            categoryId:"",
            // roomDetails:[{"roomId":"1","roomNo":"A0015","catagory":"A/C classic","rate":"100","status":"Booked"},
            // {"roomId":"3","roomNo":"A0016","catagory":"A/C classic","rate":"100","status":"Vacant"},
            // {"roomId":"4","roomNo":"A0017","catagory":"A/C classic","rate":"100","status":"Booked"},
            // {"roomId":"2","roomNo":"A0018","catagory":"A/C classic","rate":"100","status":"Vacant"}],
            currentx: 1,
            limit: 6,
            curPage: 1,
            runPage: 1,
            totalRecord: '',
            roomCategory:"",show:false,selectedRoomNo:"",selectedRoomId:""
        }
    },
    beforeMount() {
        if (this.$route.query.patientId) {
            this.patientId = this.$route.query.patientId;
        } 
        if (this.$route.query.ipNo) {
            this.ipNo = this.$route.query.ipNo;
        }else {
            this.$router.push({
                path: '*'
            });
        }
    },
    mounted(){
        this.bookedDate = this.$store.state.bookedRoomDetails.bookedDate;
        this.noofDays = this.$store.state.bookedRoomDetails.noofDays;
        const amount = this.$store.state.bookedRoomDetails.rate * this.noofDays;
        this.calcAmount = amount;
    },
    methods:{
            selectRooms(){
                this.searchRoomDetails();
                this.popupActivo = true;
            },
       searchRoomDetails(){
            const request = {
                companyId : this.$session.get('companyId'),
                categoryId : this.categoryId,
                statusType : this.statusType,
                currentPage: this.currentx,
                pageLimit: this.limit
            }
            // this.clearFields();

            this.$http.post(
                    "/searchRoomDetails",
                    JSON.stringify(request), {
                        headers: {
                            "Content-Type": "application/json"
                        }
                    }
                )
                .then(response => {
                    const details=[];
                    this.roomDetails = response.data.data;
                    this.details=JSON.stringify(response.data.data);
                    this.details = JSON.parse(this.details);
                    var totalRecors = this.details.length;
                    this.totalRecord = Math.ceil(totalRecors / this.limit);
                    // this.clearFields();
                })

        },
         storeDetails(item){
            this.show=true;
            this.popupActivo = false;
            this.selectedRoomId=item.roomId;
            this.selectedRoomNo=item.roomNo;
            this.roomCategory=item.category;
            
            console.log(JSON.stringify(item));
        },
        saveDetails(){
            var vacateRoomRequest ={
                    companyId: this.$session.get('companyId'),
                    patientId: this.patientId,
                    ipNo:this.ipNo,
                    roomNo:this.$store.state.bookedRoomDetails.roomNo,
                    roomId:this.$store.state.bookedRoomDetails.roomId,
                    userId:this.$session.get('userId'),
                }
            if(this.action == 'Vacate'){
                  console.log(JSON.stringify(vacateRoomRequest));
                this.$http.post(
                    "vacateRoom",
                    JSON.stringify(vacateRoomRequest), {
                        headers: {
                            "Content-Type": "application/json"
                        }
                    }
                )
                .then(response => {
                   this.$vs.notify({
                        title: 'Successfully Saved',
                        color: 'success',
                        iconPack: 'feather',
                        icon: 'icon-check',
                        position: 'top-center'
                    })
                }).catch(error => {
                        this.$vs.notify({
                        title: 'Error Occured While Saving',
                        color: 'danger',
                        iconPack: 'feather',
                        icon: 'icon-check',
                        position: 'top-center'
                    })
                })
            }else if(this.action == 'Change'){

                var changeRoomRequest ={
                    companyId: this.$session.get('companyId'),
                    patientId: this.patientId,
                    ipNo:this.ipNo,
                    roomData:{
                        bookingId:"New",
                        roomId:this.$store.state.bookedRoomDetails.roomId,
                        roomNo:this.$store.state.bookedRoomDetails.roomNo,
                        bookingDate:new Date().toISOString().slice(0, 10),
                        releasedFlag:"N",
                        releasedDate:""
                    },
                    userId:this.$session.get('userId'),
                }
                // this.$http.post(
                //     "vacateRoom",
                //     JSON.stringify(vacateRoomRequest), {
                //         headers: {
                //             "Content-Type": "application/json"
                //         }
                //     }
                // )
                // .then(response => {
                    this.saveChangeRoomDetails(changeRoomRequest);
                // })
            }else{
                alert('please select a radio button');
            }
        },
        saveChangeRoomDetails(request){
            console.log(JSON.stringify(request));
            this.$http.post(
                "saveRoom",
                JSON.stringify(request), {
                    headers: {
                        "Content-Type": "application/json"
                    }
                }
            ).then(response => {
                this.$vs.notify({
                    title: 'Successfully Saved',
                    color: 'success',
                    iconPack: 'feather',
                    icon: 'icon-check',
                    position: 'top-center'
                }).catch(error => {
                        this.$vs.notify({
                        title: 'Error Occured While Saving',
                        color: 'danger',
                        iconPack: 'feather',
                        icon: 'icon-check',
                        position: 'top-center'
                    })
                })
            })
        }
    }
}
</script>>

<style >
.con-vs-popup .vs-popup {
    width: 800px;
}
.inputStyles{
    font-size: 11.8px;
    font-weight: 600;
}
.topPad{
    padding-top: 7px;
}
.footer {
    position: fixed;
    left: 0;
    bottom: -20px;
    width: 100%;
    z-index: 500;
}
.example {
    margin: 20px;
}

.example input {
    display: none;
}

.example label {
    margin-right: 20px;
    display: inline-block;
    cursor: pointer;
    width: 165px;
}

.ex2 span {
    display: block;
    padding: 10px 10px 10px 10px;
    border: 2px solid #ddd;
    border-radius: 5px;
    position: relative;
    transition: all 0.25s linear;
}

.ex2 span h5 {
    padding-bottom: 5px;
}

.ex2 span:before {

    position: absolute;
    left: 5px;
    top: 50%;
    -webkit-transform: translatey(-50%);
    transform: translatey(-50%);
    width: 15px;
    height: 15px;
    border-radius: 50%;
    background-color: #ddd;
    transition: all 0.25s linear;
}

.ex2 input+span {
    background-color: #fff;
    box-shadow: 0 0 5px 2px rgba(0, 0, 0, 0.1);
}

.ex2 .blue input+span {
    color: blue;
    border-color: #00ffd291;
}

.ex2 .blue input+span:before {
    background-color: blue;
}
.ex1 span {
    display: block;
    padding: 10px 10px 10px 10px;
    border: 2px solid #ddd;
    border-radius: 5px;
    position: relative;
    transition: all 0.25s linear;
}

.ex1 span h5 {
    padding-bottom: 5px;
}

.ex1 span:before {

    position: absolute;
    left: 5px;
    top: 50%;
    -webkit-transform: translatey(-50%);
    transform: translatey(-50%);
    width: 15px;
    height: 15px;
    border-radius: 50%;
    background-color: #ddd;
    transition: all 0.25s linear;
}

.ex1 input:checked+span {
    background-color: #fff;
    box-shadow: 0 0 5px 2px rgba(0, 0, 0, 0.1);
}

.ex1 .red input:checked+span {
    color: blue;
    border-color: #00ffd291;
}

.ex1 .red input:checked+span:before {
    background-color: blue;
}
</style>
